import * as React from 'react';
import * as moment from 'moment';
import { CombinedFilterViewProps } from '../../components/filters/filter';

const FilterView: React.StatelessComponent<CombinedFilterViewProps> = props => {
    function onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        // Grab the selected option's data-first-occurance attribute.
        const selectedValue = evt.currentTarget.value;
        props.selectFilter(selectedValue);
    }

    const collapsedFilterName = props.filterName.replace(/[^\w]|_/g, "");
    if (props.options.length == 0)
        return null;

    return (
        <li className="ace-filter stack-xs" key={props.propertyToFilter}>
            <label htmlFor={`Filter-${collapsedFilterName}`}>{props.filterName}</label> 
            <select value={props.selectedValue} onChange={onChange} id={`Filter-${collapsedFilterName}`}>
                <option value="">{props.noSelectionText}</option>
                {
                    props.options.map(option => <option key={`${option.value}${option.text}`} value={option.value}> {option.text}</option>)
                }
            </select>
        </li>
    );
}

export default FilterView;